export default "__VITE_ASSET__BfPNTVX9__"